<template>
    <div class="page">
        <div class="renzhen">
            <img src="../../assets/images/infotitleimg.png" alt="" class="okimg"
                v-if="userlist.HFHIdentity.Status == 20" />
            <img src="../../assets/images/infotitlefaildimg.png" alt="" class="okimg"
                v-if="userlist.HFHIdentity.Status == 10" />
            <div class="title" v-if="userlist.HFHIdentity.Status == 20">认证成功</div>
            <div class="title" v-if="userlist.HFHIdentity.Status == 10">认证失败</div>
        </div>
        <div class="info">
            <div class="inforow">
                姓名：{{ name }}
            </div>
            <div class="inforow">
                单位：{{ lasthos }}
            </div>
            <div class="inforow">
                职称：{{ keshi }}
            </div>
        </div>
        <div class="btnrow">
            <button class="login btnleft" @click="login()">重新认证</button>
            <button class="login btnright" @click="comp()">完&nbsp;&nbsp;&nbsp;&nbsp;成</button>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'newok',
    data() {
        return {
            userlist: '',
            name: '',
            hos: '',
            keshi: '',
            lasthos: '',
        }
    },
    computed: {
    },
    created() {
        document.title = "加入ACMED";
        this.getinfo()
    },
    beforeDestroy() {

    },
    methods: {
        getinfo() {
            this.$axios.get('/api/api/web/Customer/GetMyInfo').then(res => {
                console.log(res)
                this.userlist = res.Data;
                if (this.userlist.BaseInfo.RegistType == 10 || this.userlist.BaseInfo.RegistType == 20) {
                    this.name = this.userlist.BaseInfo.RealName
                    this.hos = this.userlist.BaseInfo.Hospital
                    this.keshi = this.userlist.BaseInfo.HospitalJobTitle

                    const segments = this.hos.split('/').filter(Boolean)
                    this.lasthos = segments[segments.length - 1]
                } else if (this.userlist.BaseInfo.RegistType == 30) {
                    this.name = this.userlist.BaseInfo.RealName
                    this.hos = this.userlist.BaseInfo.Company
                    this.keshi = this.userlist.BaseInfo.CompanyJobTitle

                    const segments = this.hos.split('/').filter(Boolean)
                    this.lasthos = segments[segments.length - 1]
                }
            })
        },
        login() {
            this.$router.push({
                path: 'renzhenginfo',
            });
        },
        comp() {
            this.$router.push({
                path: 'mine',
            });
        },

    }
}
</script>

<style lang="scss" scoped>
.page {
    width: 100%;
    height: 100%;
    position: relative;
    // background: rgb(247, 249, 253);
    // background: linear-gradient(to right, #b8daf1, #cfe6f5, #a9cfec, #839ac5, #84acd2, #85b3db, #a1c7e2);
}

.totle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
}

.maintitle {
    margin: auto;
    text-align: center;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 1rem;
}

.okqrcode {
    display: block;
    margin: auto;
    width: 55%;
    margin-top: 1rem;
}

.maininner {
    width: 73%;
    margin: auto;
    font-size: 20px;
}

.topimg {
    width: 100%;
}

.renzhen {
    width: 100%;
    text-align: center;
    padding: 1rem 0;
    font-size: .46rem;
    font-weight: bold;
}

.info {
    width: 90%;
    margin: auto;
    padding-bottom: 1rem;
}

.inforow {
    padding: 0.25rem 0;
    border-bottom: 1px solid #ddd;
}

.btnrow {
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    margin: auto;
}

.login {
    width: 38%;
    padding: 0.2rem 0;
    border-radius: 10rem;
    border: 0;
}

.btnleft {
    background: #fff;
    border: 1px solid rgb(32, 40, 84);
    color: rgb(32, 40, 84);
}

.btnright {
    background: rgb(32, 40, 84);
    border: 1px solid rgb(32, 40, 84);
    color: #fff;
}

.okimg {
    display: block;
    margin: auto;
    width: 19%;
    margin-top: 2rem;
    padding-bottom: 0.3rem;
}
</style>